import { SharedService } from './../../shared.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { ApiService } from 'src/app/providers/api.service';
// import { ToastrService } from 'ngx-toastr';
// import { event } from 'jquery';
import { CommonService } from 'src/app/providers/common.service';
import { platformList, sportList } from 'src/app/shared.service';


@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})
export class FiltersComponent implements OnInit {

  @Input()
  filterType: any;

  @Input()
  initialFiltersData: any;

  @Input()
  gameStyleInitialId: any;

  @Output()
  getFiltersData = new EventEmitter<any>();

  @Output()
  getTrendsFiltersData = new EventEmitter<any>();

  @Output()
  getLast5FiltersData = new EventEmitter<any>();

  platformList = platformList;
  sportList = sportList;
  userDetail = JSON.parse(localStorage.getItem('userDetails'));
  constructor(
    public commonService: CommonService,
    private shareService: SharedService
    // private api: ApiService,
    // private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if (this.userDetail && this.userDetail.currentSport_id) {
      this.commonService.platformandsport.sport_id = this.userDetail.currentSport_id;
    }
    if (this.userDetail && this.userDetail.currentPlatform_id) {
      this.commonService.platformandsport.platform_id = this.userDetail.currentPlatform_id;
    }
    // this.subscriptionData.forEach(ele => {
    //   this.platformList.forEach(innerele => {
    //     if(ele.package_id == innerele.id){
    //       innerele.disable = false;
    //     }else{
    //       innerele.disable = true;
    //     }
    //   });
    // });
  }

  onPlatfromChange(platformId) {
    localStorage.setItem('uselocalStorage', 'no');
    if (platformId != this.commonService.platformandsport.platform_id) {
      this.shareService.updatefiltersSelection(null)
      this.commonService.platformandsport.platform_id = platformId;
      // Set current Platform
      if (this.userDetail) {
        this.userDetail.currentPlatform_id = platformId;
        localStorage.setItem('userDetails', JSON.stringify(this.userDetail));
      }
      this.sendSelectedFiltersdata();
    }
  }

  onSportChange(sportId) {
    localStorage.setItem('uselocalStorage', 'no');
    if (sportId != this.commonService.platformandsport.sport_id) {
      this.shareService.updatefiltersSelection(null)
      this.commonService.platformandsport.sport_id = sportId;
      // Set current sport
      if (this.userDetail) {
        this.userDetail.currentSport_id = sportId;
        localStorage.setItem('userDetails', JSON.stringify(this.userDetail));
      }
      this.sendSelectedFiltersdata();
    }
  }

  sendSelectedFiltersdata() {
    const data = {
      platformId: this.commonService.platformandsport.platform_id.toString(),
      sportId: this.commonService.platformandsport.sport_id.toString(),
    };
    this.shareService.updatefiltersSelection(null, '')
    this.shareService.clearFilters.next(data)
    this.getFiltersData.emit(data);
  }

  // changeGameStyle(item, type) {
  //   this.filters.slate = '';
  //   if (item == "") {
  //     this.slate = [];
  //   } else {
  //     if (this.initialFiltersData && this.initialFiltersData.gameStyleList) {
  //       this.initialFiltersData.gameStyleList.forEach(element => {
  //         if (item == element.game_style_id && element.slates.length > 0) {
  //           this.slate = element.slates;
  //           if (type == 'DefaultSelectedSlate') {
  //             this.filters.slate = this.slate[0].slates_id;
  //           }
  //         }
  //       });
  //     }
  //   }

  //   this.sendSelectedFiltersdata();

  // }

  // onExclude(event) {
  //   if (event.target.checked) {
  //     this.filters.excludehighlow = '1';
  //   } else {
  //     this.filters.excludehighlow = '0';
  //   }

  //   this.sendSelectedFiltersdata();
  // }

  // changeTypeDisplay(event) {
  //   this.filters.typedisplay = event.target.value;
  //   this.sendSelectedFiltersdata();
  // }

  // changeHA(event) {
  //   this.filters.ha = event.target.value;
  //   this.sendSelectedFiltersdata();
  // }



  // onTrendsFilters(item) {
  //   this.getTrendsFiltersData.emit({ page: 'Trends', test: 12 })
  // }

  // onLast5Filters(item) {
  //   this.getLast5FiltersData.emit({ pag: 'Last 5', test: 12 })
  // }

}
